import { RolesKeyType } from 'constant/roles'
import { lazy } from 'react'
import { ModifierPageRBAC } from 'features/Product/pages/Modifier/rbac'
import { ModifierAddPageRBAC } from 'features/Product/pages/ModifierAdd/modifier-add.rbac'
import { ModifierEditPageRBAC } from 'features/Product/pages/ModifierAdd/modifier-edit.rbac'
import { ModifierConnectionPageRBAC } from 'features/Product/pages/ModifierConnection/rbac'

export type ModifierNamedRoutesType =
  | 'ModifierRouter'
  | 'ModifierConnectionRouter'
  | 'ModifierAddRouter'
  | 'ModifierEditRouter'
export type ModifierPathListsType =
  | '/dashboard/modifier'
  | '/dashboard/modifier-connection'
  | '/dashboard/modifier/add'
  | '/dashboard/modifier/edit/:modifierId'

type RouterInstanceType = RouterFeatureInterface<ModifierNamedRoutesType, ModifierPathListsType>

const ModifierPage = lazy(() => import('../pages/Modifier'))
const ModifierConnectionPage = lazy(() => import('../pages/ModifierConnection'))
const ModifierAdd = lazy(() => import('../pages/ModifierAdd'))

export const roleViewOnly: RolesKeyType[] = [
  'AUTH_SUPPLY_CHAIN',
  'AUTH_HO_ASTRO_KITCHEN_MANAGER',
  'AUTH_HO_ASTRO_KITCHEN_SOURCING',
  'AUTH_HO_ASTRO_KITCHEN_SUPPLY_CHAIN',
  'AUTH_HO_ASTRO_KITCHEN_STAFF',
]

const ModifierRouter: RouterInstanceType = {
  name: 'ModifierRouter',
  Component: ModifierPage,
  path: '/dashboard/modifier',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ModifierPageRBAC.pageID,
  isDashboard: true,
}

const ModifierConnectionRouter: RouterInstanceType = {
  name: 'ModifierConnectionRouter',
  Component: ModifierConnectionPage,
  path: '/dashboard/modifier-connection',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ModifierConnectionPageRBAC.pageID,
  isDashboard: true,
}

const ModifierAddRouter: RouterInstanceType = {
  name: 'ModifierAddRouter',
  Component: ModifierAdd,
  path: '/dashboard/modifier/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ModifierAddPageRBAC.pageID,
  isDashboard: true,
}

const ModifierEditRouter: RouterInstanceType = {
  name: 'ModifierEditRouter',
  Component: ModifierAdd,
  path: '/dashboard/modifier/edit/:modifierId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ModifierEditPageRBAC.pageID,
  isDashboard: true,
}

const ModifierRouterList: RouterInstanceType[] = [
  ModifierRouter,
  ModifierConnectionRouter,
  ModifierAddRouter,
  ModifierEditRouter,
]

export default ModifierRouterList
